var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "product-image",
        class: {
          "product-image--height": _vm.basic,
          "product-image--width": !_vm.basic
        },
        style: _vm.style
      },
      _vm.$listeners
    ),
    [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPlaceholder,
            expression: "showPlaceholder"
          }
        ],
        staticClass: "product-image__placeholder",
        attrs: { src: "/assets/placeholder.svg", alt: _vm.alt }
      }),
      _vm._v(" "),
      !_vm.lowerQualityImageError || _vm.isOnline
        ? _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLowerQuality,
                expression: "showLowerQuality"
              },
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.image.loading,
                expression: "image.loading"
              }
            ],
            ref: "lQ",
            staticClass: "product-image__thumb",
            attrs: { alt: _vm.alt },
            on: {
              load: function($event) {
                return _vm.imageLoaded("lower", true)
              },
              error: function($event) {
                return _vm.imageLoaded("lower", false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.highQualityImageError || _vm.isOnline
        ? _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showHighQuality,
                expression: "showHighQuality"
              },
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.image.src,
                expression: "image.src"
              }
            ],
            staticClass: "product-image__thumb",
            attrs: { alt: _vm.alt },
            on: {
              load: function($event) {
                return _vm.imageLoaded("high", true)
              },
              error: function($event) {
                return _vm.imageLoaded("high", false)
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }